import listing from './modules/listing/store';
import search from './modules/search/store';
import polygon from './modules/polygon/store';

export default {
  listing,
  search,
  polygon,
};
